import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { CoachingArtifact } from "../hooks/useCoachingArtifacts";
import { createArtifactsActions } from "./actions/artifactsActions";
import { createAttributeSelectionActions } from "./actions/attributeSelectionActions";
import { createConfigurationActions } from "./actions/configurationActions";

export interface CoachingGeneratorState {
  customPrompt: string;
  systemPrompt: string;
  temperature: number;
  includeAttributeStats: boolean;
  includeLensDefinition: boolean;
  includeTeamBestPractices: boolean;
  selectedAttributes: Set<string>;
  expandedAttribute: string | null;
  existingArtifacts: CoachingArtifact[];
}

export interface ConfigurationActions {
  setCustomPrompt: (prompt: string) => void;
  setSystemPrompt: (prompt: string) => void;
  setTemperature: (temperature: number) => void;
  setIncludeAttributeStats: (include: boolean) => void;
  setIncludeLensDefinition: (include: boolean) => void;
  setIncludeTeamBestPractices: (include: boolean) => void;
}

export interface AttributeSelectionActions {
  toggleAttribute: (attribute: string) => void;
  selectAllAttributes: (attributes: string[]) => void;
  clearSelectedAttributes: () => void;
  setExpandedAttribute: (attribute: string | null) => void;
}

export interface ArtifactsActions {
  setExistingArtifacts: (artifacts: CoachingArtifact[]) => void;
}

export interface CoachingGeneratorActions
  extends ConfigurationActions,
  AttributeSelectionActions,
  ArtifactsActions {}

type CoachingGeneratorStore = CoachingGeneratorState & CoachingGeneratorActions;

export const useCoachingGeneratorStore = create<CoachingGeneratorStore>()(
  devtools(
    (set) => ({
      customPrompt: "",
      systemPrompt: "",
      temperature: 0.1,
      includeAttributeStats: true,
      includeLensDefinition: true,
      includeTeamBestPractices: true,
      selectedAttributes: new Set<string>(),
      expandedAttribute: null,
      existingArtifacts: [],

      ...createConfigurationActions(set),
      ...createAttributeSelectionActions(set),
      ...createArtifactsActions(set)
    }),
    {
      name: "coaching-generator-store"
    }
  )
);
